exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".maintenance-info-edit {\n  width: 400px; }\n  .maintenance-info-edit textarea {\n    width: 400px;\n    height: 200px; }\n  .maintenance-info-edit .buttons {\n    margin-top: 10px;\n    text-align: right; }\n    .maintenance-info-edit .buttons button {\n      margin-right: 5px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader/lib/loader.js!./styles/maintenance-info-edit.scss
// module id = 556
// module chunks = 0